import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import {
  getDatadogRumApplicationId,
  getDatadogRumClientToken,
} from '@hopin-team/dashboard-constants';

class Logger {
  private isDatadogEnabled() {
    return (
      !!getDatadogRumApplicationId() &&
      !!getDatadogRumClientToken() &&
      process.env.NODE_ENV !== 'development'
    );
  }

  error(message: string, extra?: any) {
    if (this.isDatadogEnabled()) {
      if (extra instanceof Error) {
        datadogRum.addError(extra, {
          errorMessage: message,
        });
      } else {
        const error = new Error(message);
        datadogRum.addError(error, {
          extra,
        });
      }
      // Also log to Datadog Logs for better searchability
      datadogLogs.logger.error(message, extra);
    } else {
      console.error(`[ERROR]: ${message}`, extra);
    }
  }

  warning(message: string) {
    if (this.isDatadogEnabled()) {
      datadogLogs.logger.warn(message);
    } else {
      console.warn(`[WARNING]: ${message}`);
    }
  }

  info(...args: any[]) {
    console.log(`[INFO]:`, ...args);
  }

  log(...args: any[]) {
    this.info(...args);
  }
}

export const logger = new Logger();
